import { useEffect } from 'react';

export const VISUAL_VIEWPORT_KEYBOARD_INSET_VAR = '--visual-viewport-keyboard-inset';

export const getRemainingVisualViewportHeight = (
  elementTop: number,
  viewportHeight: number,
): number => Math.max(0, Math.round(viewportHeight - Math.max(elementTop, 0)));

/**
 * Keeps sticky footers above the soft keyboard by exposing the overlap
 * between the layout viewport and the visual viewport as a CSS variable.
 */
const useVisualViewportInset = (
  cssVariable: string = VISUAL_VIEWPORT_KEYBOARD_INSET_VAR,
): void => {
  useEffect(() => {
    const root = document.documentElement;
    const viewport = window.visualViewport;

    const syncInset = () => {
      if (!viewport) {
        root.style.setProperty(cssVariable, '0px');
        return;
      }

      const overlap = Math.max(0, window.innerHeight - viewport.height - viewport.offsetTop);
      root.style.setProperty(cssVariable, `${Math.round(overlap)}px`);
    };

    syncInset();

    if (!viewport) {
      return undefined;
    }

    viewport.addEventListener('resize', syncInset);
    viewport.addEventListener('scroll', syncInset);
    window.addEventListener('orientationchange', syncInset);

    return () => {
      viewport.removeEventListener('resize', syncInset);
      viewport.removeEventListener('scroll', syncInset);
      window.removeEventListener('orientationchange', syncInset);
      root.style.setProperty(cssVariable, '0px');
    };
  }, [cssVariable]);
};

export default useVisualViewportInset;
